import { render, staticRenderFns } from "./NewView.vue?vue&type=template&id=48870700"
import script from "./NewView.vue?vue&type=script&lang=js"
export * from "./NewView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports